<template>
  <div>
    <center>
      <h1>Not Found</h1>
      <!--       <h3 v-if="context">Context: {{ context }}</h3>
 -->
      <p>This is not the droid you are looking for...</p>
    </center>
  </div>
</template>

<script>
export default {
  name: "NotFound",
  data() {
    return {
      context: null,
    };
  },
  created: function () {
    this.initialize();
  },
  mounted: function () {
    // this.initialize();
  },
  methods: {
    initialize() {
      let client = this.$client;
      client.getContext().then((c) => {
        this.context = c;
      });
    },
  },
};
</script>